import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7e6046c2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-right-full-page-section" }
const _hoisted_2 = { class: "modal-dialog-right" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = { class: "modal-title" }
const _hoisted_6 = { class: "modal-body" }
const _hoisted_7 = { class: "image-icon" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "body-topic" }
const _hoisted_10 = { class: "body-title" }
const _hoisted_11 = { class: "body-highlight" }
const _hoisted_12 = { class: "card-panel" }
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = { class: "body-description" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { class: "modal-footer" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { class: "btn-content-text" }

export function render(_ctx, _cache) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(['modal-right-full-page', _ctx.modalOptions.classNameHeader, 'show', {hide: _ctx.isClose}])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("button", {
              class: "arrow",
              onClick: _cache[0] || (_cache[0] = $event => (_ctx.closeModal()))
            }, [
              _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-chevron-left" })
            ]),
            _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.modalOptions.title), 1)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              (_ctx.modalOptions?.image)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: require('../../assets/img/' + _ctx.modalOptions.image + '.png')
                  }, null, 8, _hoisted_8))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.modalOptions.body?.topic), 1),
            _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.modalOptions.body?.title), 1),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("span", {
                  innerHTML: _ctx.modalOptions.body?.highlight
                }, null, 8, _hoisted_13)
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              (_ctx.modalOptions.body?.descriptionBullet)
                ? (_openBlock(), _createElementBlock("ul", _hoisted_15, [
                    _createElementVNode("li", null, _toDisplayString(_ctx.modalOptions.body?.description), 1)
                  ]))
                : (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(_ctx.modalOptions.body?.description), 1))
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.modalOptions.actionOptions, (item) => {
              return (_openBlock(), _createElementBlock("button", {
                class: "btn",
                style: _normalizeStyle({color: item.color ? item.color : '#424242', backgroundColor: item.backgroundColor ? item.backgroundColor : '#E8E8E8', borderColor: item.backgroundColor ? item.backgroundColor : '#E8E8E8'}),
                onClick: $event => (item?.action ? item.action() : _ctx.closeModal())
              }, [
                _createElementVNode("span", _hoisted_19, _toDisplayString(item.text ? item.text : 'Close'), 1)
              ], 12, _hoisted_18))
            }), 256))
          ])
        ])
      ])
    ], 2)
  ]))
}